import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const SelectFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('SelectField'),
});

export type SelectField = z.infer<typeof SelectFieldSchema>;